import React from 'react';
import { isEqual } from 'lodash';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete';
import { useAddressQuery } from '~/queries/useAddressQuery';
import { FormInput } from '~/components/FormComponents/FormInput';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface ICountryInfoBlockProps {
  section?: string;
  isDisabledForm?: boolean;
  isCitizenshipCountry?: boolean;
  isResidenceCountry?: boolean;
  isBirthplaceCountry?: boolean;
  isBirthPlace?: boolean;
}

const CountryInfoBlock = ({
  section,
  isDisabledForm,
  isBirthplaceCountry = true,
  isCitizenshipCountry = true,
  isResidenceCountry = true,
  isBirthPlace = true,
}: ICountryInfoBlockProps) => {
  const { nonAgressionCountryOptions, countryOptions } = useAddressQuery();
  const prefix = section ? section + '.' : '';
  return (
    <>
      {isCitizenshipCountry && (
        <FormGridItem>
          <FormAutocomplete
            name={`${prefix}citizenshipCountry`}
            options={countryOptions}
            disabled={isDisabledForm}
            inputProps={{
              placeholder: 'Оберіть країну громадянства',
            }}
            label="Країна громадянства"
            fullWidth
          />
        </FormGridItem>
      )}
      {isResidenceCountry && (
        <FormGridItem>
          <FormAutocomplete
            name={`${prefix}residenceCountry`}
            options={nonAgressionCountryOptions}
            disabled={isDisabledForm}
            placeholder="Оберіть країну резидентства"
            inputProps={{
              placeholder: 'Оберіть країну резидентства',
            }}
            label="Країна резидентства"
            fullWidth
          />
        </FormGridItem>
      )}
      {isBirthplaceCountry && (
        <FormGridItem>
          <FormAutocomplete
            name={`${prefix}birthplaceCountry`}
            options={countryOptions}
            disabled={isDisabledForm}
            inputProps={{
              placeholder: 'Оберіть країну народження',
            }}
            label="Країна народження"
            fullWidth
          />
        </FormGridItem>
      )}
      {isBirthPlace && (
        <FormGridItem>
          <FormInput
            name={`${prefix}birthPlace`}
            label="Місце народження"
            placeholder="Введіть місце народження"
            disabled={isDisabledForm}
            fullWidth
            inputProps={{
              maxLength: 120,
            }}
          />
        </FormGridItem>
      )}
    </>
  );
};

const areEqual = (prevProps: ICountryInfoBlockProps, nextProps: ICountryInfoBlockProps) => {
  return isEqual(prevProps, nextProps);
};

export default React.memo(CountryInfoBlock, areEqual);
